var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgForum = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.2-227.56q-19.63 0-32.57-13.09-12.93-13.08-12.93-32.42v-85.5h526.93v-366.45h85.5q19.34 0 32.42 13.08 13.08 13.08 13.08 32.42v614.11L731.48-227.56H281.2ZM66.37-274.98v-574.11q0-19.33 13.08-32.42 13.08-13.08 32.42-13.08h525.26q19.34 0 32.42 13.08 13.08 13.09 13.08 32.42v365.02q0 19.34-13.08 32.42-13.08 13.08-32.42 13.08H230.2L66.37-274.98Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgForum, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/forum.80c40e53.svg";
export { ForwardRef as ReactComponent };